<template>
    <div>
        <div class="top_bg">
	<div class="top_wrap">
    	<div class="top">
        	<div class="top_icon">
            </div>
        	<h1>Thank you.</h1>
        </div>

        <div class="top_content">
        	<div class="top_content_text">
            	<p>Your inquiry has been successfully received.<br/>
We'll contact to the person who made this inquiry within 1 business day via email or on the phone.<br/>
 </p>
            </div>
        </div>

        <div class="top_close_bg">
            <div class="top_close_wrap">
                <div class="top_close">
                    <a onClick="javascript:window.close();" class="top_btn" > Close </a>
                </div>
            </div>
        </div>


    </div>
</div>
    </div>
</template>
<script>
    export default {
        mounted() {
            window.resizeTo(900, 435);
        }
    }
</script>
<style scoped>
    @import '../../../assets/css/thankyou_css.css';
</style>